module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/arrow-purple-small-038ca96c13f9e69607fcce1cad2843b0.svg";